module.exports = {
  NONE: 0,
  INFER: 1,
  PATTERN: 2,
  MATCH_UA: 4,
  MATCH_PROF: 8,
};
